module.exports = __webpack_public_path__ + "static/media/cap.60fe0da4.svg";